import {Button, HStack, Portal, Menu, Icon} from "@chakra-ui/react";
import {useChat} from "@/components/providers/ChatProvider";
import {CgMoreAlt} from "react-icons/cg";
import ChatContainer from "@/components/ui/chat/ChatContainer";

const ChatWidgets = () => {
    const {
        visibleChats,
        hiddenChats,
        openChat,
        sendMessage,
        closeChat
    } = useChat();

    if (visibleChats.length === 0 && hiddenChats.length === 0) {
        return null;
    }

    return (
        <HStack w={'100%'} position={'fixed'} bottom={0} right={0} justifyContent={'flex-end'} columnGap={4}
                alignItems={'flex-end'} px={8} py={0} zIndex="tooltip">
            {hiddenChats.length > 0 && (
                <Menu.Root>
                    <Menu.Trigger asChild>
                        <Button bg={'white'} borderRadius={'full'} aspectRatio={1} mb={4} fontSize={'unset'}>
                            <Icon fontSize={24} color={'blue'}>
                                <CgMoreAlt/>
                            </Icon>
                        </Button>
                    </Menu.Trigger>
                    <Portal>
                        <Menu.Positioner>
                            <Menu.Content>
                                {hiddenChats.map((hiddenChat) => (
                                    <Menu.Item key={hiddenChat.id} value={hiddenChat.id}
                                               onClick={() => openChat(hiddenChat.id)}>
                                        {hiddenChat.name} ({hiddenChat.id.slice(hiddenChat?.id.length - 5, hiddenChat?.id.length)})
                                    </Menu.Item>
                                ))}
                            </Menu.Content>
                        </Menu.Positioner>
                    </Portal>
                </Menu.Root>
            )}
            {visibleChats.map((chat) => (
                <ChatContainer chat={chat} key={chat.id} onSendMessage={sendMessage}
                               onClose={() => closeChat(chat.id)}/>
            ))}
        </HStack>
    );
}

export default ChatWidgets;
